import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { update } from "../../../state/bordersSlice";
import ColorPickerSubMenu from "../submenus/ColorPickerSubMenu";

const BorderColorMenuItem = () => {
  const selection = useSelector((state) => state.selection.borders[0]);
  const selectedBorder = useSelector((state) => state.gridd.present.borders.find((b) => b.id === selection.id));
  const dispatch = useDispatch();

  return (
    <div>
      <div style={{ display: "grid", gridTemplateRows: "auto auto auto" }}>
        <ColorPickerSubMenu
          color={selectedBorder?.color}
          enabled={["nocolor", "base", "status"]}
          onNewColor={(newColor, newName) => {
            dispatch(update({ id: selectedBorder.id, color: newColor, colorName: newName }));
          }}
        />
      </div>
    </div>
  );
};

export default BorderColorMenuItem;
